  
<div class="row">
  <app-dashboard-menu></app-dashboard-menu>

    <div class="dashboardContentBox">     
         <div class="col-12">
           <div class="status-card-panel">
            <div class="status-card">{{'pendingworking' | translate}} :{{this.totalPending}}</div>
            <div class="status-card">{{'activeworking' | translate}} :{{this.totalActiveWorking}}</div>
            <div class="status-card">{{'completedWorking' | translate}}:{{this.totalCompleted}}</div>
           </div>    
         </div>   
    </div>   
    <div class="dashboardContentBox">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
               <div class="row">
                  <div class="col-12">
                      <div class="table-responsive">
                        <table datatable #dtElement  [dtOptions]="dtOptions" class="table width-100">
                            <!-- <table  class="table width-100"> -->
                          <thead>
                            <tr class="bg-primary text-white">
                              
                              <th>{{'trackingNo' | translate}}</th>       
                              <th>{{'assignDate' | translate}}</th>                 
                              <th>{{'customer' | translate}}</th>
                              <th>{{'requiredname' | translate}}</th>
                              <th>{{'implementationTypes' | translate}}</th>
                              <th>{{'serviceStatus' | translate}}</th>
                              <th>{{'assignedTo' | translate}}</th>                          
                              <th>{{'lastAction' | translate}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- [ngClass]="{'background-row-delay-color': order.isExceededDate === true && order.statusId !== requestStatusEnum.Cancelled && order.statusId !== requestStatusEnum.Completed && isCustomer === false && isCourt === false}" -->
                            <tr *ngFor="let order of ordersList"
                            
                              [ngClass]="{
                                'background-row-pending-color': order.workStationStatus === 'Pending',
                                'background-row-active-color': order.workStationStatus === 'Active',
                                'background-row-complete-color': order.workStationStatus === 'Complete',
                                'background-row-delay-color': order.isExceededDate === true 
                                && order.statusId !== requestStatusEnum.Cancelled 
                                && order.statusId !== requestStatusEnum.Completed
                                 }"
                              >
                              
                              <td>
                                <a class="main-color" routerLink="/order/orderServiceDetails/{{order.requestOrderDetailId}}">
                                {{order.trackingNo}}</a> 
                                <!-- <br>
                                {{order.workStationStatus}} -->
                                 <br>
                               {{order.createdOn|customDate:"dd MMM, yyyy,hh:mm a"}}
                                  </td>
                                  <td>{{order.assignedDate|customDate:"dd MMM, yyyy,hh:mm a"}}</td>
                              <td>{{order.customer}}</td>
                              <td>{{ order.requiredName }}</td>
                              <td>{{ order.implementationType }}</td>
                             
                              <td>
                                <!-- {{ order.status }} -->
                                <span
                                  *ngIf="order.statusId !== 6">{{order.status | translate}}
                                </span>
                                <span
                                  *ngIf="order.statusId === 6"
                                  style="color: rgb(0, 205, 34);">{{order.status | translate}}
                                </span>
                                 <br>
                                <span
                                  *ngIf="order.statusId === 2 && order.assignedTo !== null"
                                  style="color: mediumblue;">({{'assigned' | translate}})
                                </span>
                              </td>
                               <td>
                                <a class="main-color" routerLink="/user/userDetails/{{order.assignedUserId}}"
                                  href="javascript:(void)">
                                {{ order.assignedTo }}
                                 </a>
                                <br>  
                                 <a class="main-color" routerLink="/user/userDetails/{{order.assignedAuditUserId}}"
                                  href="javascript:(void)">
                                {{ order.assignedAuditUser}}
                                </a>
                                </td>
                              

                              
                              <!-- <td>{{ order.assignedTo| customDate:"dd MMM, yyyy hh:mm a" }}</td> -->
                              <td> 
                                  {{order.lastAction | customDate:"dd MMM, yyyy,hh:mm a"}}
                                  
                              </td>
                            

                            </tr>
                          </tbody>
                          <tbody *ngIf="ordersList?.length == 0">
                            <tr>
                              <td colspan="10" class="no-data-available">{{'noDataFound' | translate}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                   </div>
                </div>
            </div>
          </div>
        </div>
    </div>
  <!-- <div class="DashboardContentArea"> -->
      <!-- <div class="dashboardContentAreaLefts"> -->
         <div class="dashboardContentBox">
            <div class="dashboardContentBoxHeading">              
              {{'inWork' | translate}}
            </div>
            <div class="dashboardContentBoxBody">
                
                <div style="display: block">
                    <canvas baseChart
                        [datasets]="barChartDataInWork"
                        [labels]="barChartLabelsInWork"
                        [options]="barChartOptions"
                        [colors]="barChartColorsInWork"          
                        [chartType]="barChartType"
                        (chartHover)="chartHovered($event)"                                                             
                        (chartClick)="chartClicked($event)"></canvas>

                </div>
            </div>
         </div>
        <div class="dashboardContentBox">
          <div class="dashboardContentBoxHeading">
                    
                     {{'return' | translate}}
          </div>
          <div class="dashboardContentBoxBody">
              <div style="display: block">
                  <canvas baseChart
                      [datasets]="barChartDataReturn"
                      [labels]="barChartLabelsReturn"
                      [options]="barChartOptions"
                      [colors]="barChartColorsReturn"          
                      [chartType]="barChartType"
                      (chartHover)="chartHovered($event)"                                                             
                      (chartClick)="chartClicked($event)"></canvas>

              </div>   
          </div>
        </div>
      <!-- </div> -->
      
      <!-- <div class="dashboardContentAreaRights " style="grid-template-columns:100%;">        -->
      
     
  <!-- </div> -->
</div>              
